import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col" }
const _hoisted_2 = { class: "mb-2 text-lg font-semibold" }
const _hoisted_3 = { class: "min-w-full border-separate border-spacing-0" }
const _hoisted_4 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_5 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_6 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_7 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_8 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_9 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_10 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }

import moment from 'moment';
import orderBy from 'lodash/orderBy';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { applyPhoneMask } from '@/utils/number';
import { formatSecToTime } from '@/utils/datetime';
import {
    UserDeviceStatus,
    UserQueueStatus,
    UserExtensionQuality,
    RealtimeReportServiceGetUserDevicesResult,
} from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDevicesTable',
  props: {
    userDevices: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const pingToQuality = (ping: number | null | undefined): UserExtensionQuality => {
    if (typeof ping !== 'number' || ping < 1) return UserExtensionQuality.UNAVAILABLE;
    if (ping > 205) return UserExtensionQuality.LOW;
    if (ping > 150) return UserExtensionQuality.MEDIUM;
    return UserExtensionQuality.HIGH;
};

const getCallDuration = (callCreationTime: Date | null | undefined): string => {
    if (!callCreationTime) return '';
    const seconds = moment.duration(moment().diff(moment(callCreationTime))).asSeconds();
    return formatSecToTime(seconds);
};
const computedUserDevices = computed(() => {
    const sorted = orderBy(
        props.userDevices,
        [
            (ud) => ud.user.extension?.number || '',
            (ud) => ud.user.name || '',
            (ud) => ud.deviceType || '',
        ],
        ['asc', 'asc', 'asc'],
    );

    return sorted.map((ud) => ({
        key: `${ud.user.id}_${ud.deviceType}`,
        extension: ud.user.extension?.number || '',
        name: ud.user.name || '',
        deviceTypeLabel: t(`core.device.${ud.deviceType}`),
        statusLabel: t(
            `report.realtime.device.status.${ud.state?.status || UserDeviceStatus.OFFLINE}`,
        ),
        statusClass:
            !ud.state?.status || ud.state.status === UserDeviceStatus.OFFLINE
                ? 'bg-danger-100 text-danger-700'
                : 'bg-success-50 text-success-700',
        queueStatusLabel: t(
            `report.realtime.user.queueStatus.${ud.user?.queueStatusHistory?.length ? UserQueueStatus.PAUSED : UserQueueStatus.UNPAUSED}`,
        ),
        queueStatusClass: ud.user?.queueStatusHistory?.length
            ? 'bg-danger-100 text-danger-700'
            : 'bg-success-50 text-success-700',
        phoneNumber: ud.state?.phoneNumber ? applyPhoneMask(ud.state.phoneNumber) : '',
        qualityLabel: t(`report.realtime.device.quality.${pingToQuality(ud.state?.ping)}`),
        callTypeLabel: ud.state?.callType ? t(`call.type.${ud.state.callType}`) : '',
        duration: getCallDuration(ud.state?.callCreationTime),
    }));
});

return (_ctx: any,_cache: any) => {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('report.realtime.userDevicesTable.title')), 1),
    _createVNode(_component_UiPanel, {
      class: "flex-1 overflow-y-auto",
      "no-padding": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                'extension',
                                'user',
                                'device',
                                'status',
                                'queueStatus',
                                'numberClient',
                                'quality',
                                'type',
                                'duration',
                            ], (header) => {
                return _createElementVNode("th", {
                  key: header,
                  class: _normalizeClass(["sticky top-0 z-10 whitespace-nowrap border-b border-gray-300 bg-gray-200 px-3 py-1.5 text-sm font-semibold text-gray-800 backdrop-blur backdrop-filter", {
                                'text-left': [
                                    'extension',
                                    'user',
                                    'numberClient',
                                    'quality',
                                ].includes(header),
                                'text-center': [
                                    'device',
                                    'status',
                                    'queueStatus',
                                    'quality',
                                    'type',
                                    'duration',
                                ].includes(header),
                            }])
                }, _toDisplayString(_ctx.$t(`report.realtime.userDevicesTable.header.${header}`)), 3)
              }), 64))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedUserDevices.value, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id,
                class: "even:bg-gray-100"
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(item.extension), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(item.name), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(item.deviceTypeLabel), 1),
                _createElementVNode("td", {
                  class: _normalizeClass([
                                item.statusClass,
                                'whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium',
                            ])
                }, _toDisplayString(item.statusLabel), 3),
                _createElementVNode("td", {
                  class: _normalizeClass([
                                item.queueStatusClass,
                                'whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium',
                            ])
                }, _toDisplayString(item.queueStatusLabel), 3),
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.phoneNumber), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(item.qualityLabel), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(item.callTypeLabel), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(item.duration), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})